import { gql } from '@apollo/client';

export default gql`
  query validateVoucher($reference: String!, $bookingReference: String!, $isDepositPayment: Boolean = false) {
    validateVoucher(reference: $reference, bookingReference: $bookingReference, isDepositPayment: $isDepositPayment) {
      isValid
      reason
      voucher {
        reference
        type
        amount
        balance
        currency
        validUntil
      }
    }
  }
`;
